import { path } from 'ramda';
import type { DicomInfo } from '@/lib/dicom/DicomInfo';

export class DicomInfoUtil {
    public static verticalImagePositionPatient(previousDicom: DicomInfo): number | undefined {
        return path<number>(['imagePositionPatient', 2], previousDicom);
    }
}
